import { Sorter } from '@common/services';

export const ETABLISSEMENTS_TRIE_DEFAUT: Sorter[] = [
  { field: 'principal', direction: 'desc' },
  { field: 'denominationUsuelle', direction: 'asc' }];